module.exports = __webpack_public_path__ + "img/error.af4748ad.png";